export default {
	home: {
		name: ""
	},
	page_out_trade_no: "상점 주문 번호",
	submit_modeling_model_file_not_ready:
		"모델 파일이 아직 준비되지 않았습니다. 잠시 후 다시 시도하거나 고객센터에 문의해 주세요."
};
